import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MsisdnService } from './msisdn.service';
import { Msisdn } from './msisdns';

@Injectable()
export class HistoricalMsisdnResolver implements Resolve<Msisdn[]> {
  constructor(private msisdnService: MsisdnService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<Msisdn[]> | Promise<Msisdn[]> | Msisdn[] {
    return this.msisdnService.historicalMsisdns();
  }
}
